import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'formatarDataBR'
})
export class DateUtil implements PipeTransform {
    transform(value?: Date | string): string {
        if (!value) {
            return '-';
        }

        if (typeof value === 'string' && value.length === 8 && !isNaN(Number(value))) {
            const ano = value.substring(0, 4);
            const mes = value.substring(4, 6);
            const dia = value.substring(6, 8);
            value = `${ano}-${mes}-${dia}`;
        }

        const datePipe = new DatePipe('pt-BR');
        return datePipe.transform(value, 'dd/MM/yyyy') || '';
    }
}